(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collection-ranking"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const settingsScript = document.getElementById('tab-carousel-settings');
  const settings = JSON.parse(settingsScript.textContent);
  
  let tabButtons = document.querySelectorAll(".tab-button");
  let tabContents = document.querySelectorAll('.tab-content');
  let tabScroll = document.getElementById('tabScroll');
  
  let currentTabIndex = 0;
  let autoCarouselInterval = null;
  let isAutoCarouselStopped = false;
  let isAutoScrolling = false; // 自動スクロール中フラグ

  // 初期化
  function initializeTabs() {
    tabContents.forEach(function(content, index) {
      if(index === 0) {
        content.setAttribute('aria-hidden', 'false');
        content.style.opacity = "1";
        content.style.display = "block";
        content.style.transform = "translateY(0)";
      } else {
        content.setAttribute('aria-hidden', 'true');
        content.style.opacity = "0";
        content.style.display = "none";
        content.style.transform = "translateY(30px)";
      }
    });

    if (tabButtons.length > 0) {
      tabButtons[0].classList.add('active-tab');
    }
  }

  // アクティブタブを画面中央にスクロール
  function scrollToActiveTab(tabIndex) {
    if (!tabButtons[tabIndex] || !tabScroll) return;
    
    const activeTab = tabButtons[tabIndex];
    const scrollContainer = tabScroll;
    const containerWidth = scrollContainer.offsetWidth;
    const tabWidth = activeTab.offsetWidth;
    const tabLeft = activeTab.offsetLeft;
    
    // 自動スクロール中フラグを立てる
    isAutoScrolling = true;
    
    // タブを中央に配置するための計算
    const scrollPosition = tabLeft - (containerWidth / 2) + (tabWidth / 2);
    
    scrollContainer.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });

    // スクロール完了後にフラグを解除
    setTimeout(function() {
      isAutoScrolling = false;
    }, 500);
  }

  // タブ切り替え関数
  function switchToTab(tabIndex) {
    if (tabIndex >= tabButtons.length || tabIndex < 0) return;
    
    // すべてのタブからactive-tabクラスを削除
    tabButtons.forEach(function(button) {
      button.classList.remove('active-tab');
    });
    
    // 新しいタブにactive-tabクラスを追加
    tabButtons[tabIndex].classList.add('active-tab');
    
    // 現在のアクティブコンテンツを非表示
    let currentActive = document.querySelector('.tab-content[aria-hidden="false"]');
    if (currentActive) {
      currentActive.style.opacity = "0";
      currentActive.setAttribute('aria-hidden', 'true');
      currentActive.style.transform = "translateY(30px)";
      
      setTimeout(function() {
        currentActive.style.display = "none";
        
        // 新しいコンテンツを表示
        let newContent = document.querySelector('.tab-content[data-tab="' + (tabIndex + 1) + '"]');
        if (newContent) {
          newContent.setAttribute('aria-hidden', 'false');
          newContent.style.display = "block";
          setTimeout(function() {
            newContent.style.opacity = "1";
            newContent.style.transform = "translateY(0)";
          }, 50);
        }
      }, 300);
    }
    
    // タブを中央にスクロール
    scrollToActiveTab(tabIndex);
    
    currentTabIndex = tabIndex;
  }

  // 自動カルーセル開始
  function startAutoCarousel() {
    if (!settings.enableAutoCarousel || isAutoCarouselStopped || settings.totalTabs <= 1) return;
    
    autoCarouselInterval = setInterval(function() {
      if (isAutoCarouselStopped) {
        clearInterval(autoCarouselInterval);
        return;
      }
      
      // 次のタブインデックスを計算（無限ループ）
      const nextIndex = (currentTabIndex + 1) % settings.totalTabs;
      switchToTab(nextIndex);
    }, settings.carouselInterval);
  }

  // 自動カルーセル停止
  function stopAutoCarousel() {
    isAutoCarouselStopped = true;
    if (autoCarouselInterval) {
      clearInterval(autoCarouselInterval);
      autoCarouselInterval = null;
    }
  }

  // タブクリックイベント
  tabButtons.forEach(function(tabButton, index) {
    tabButton.addEventListener("click", function(e) {
      e.preventDefault();
      stopAutoCarousel();
      switchToTab(index);
    });
  });

  // タブスクロールでの手動操作検知（自動スクロール中は無視）
  tabScroll.addEventListener('scroll', function() {
    if (!isAutoScrolling && !isAutoCarouselStopped) {
      stopAutoCarousel();
    }
  });

  // タッチ操作での自動カルーセル停止
  tabScroll.addEventListener('touchstart', function() {
    stopAutoCarousel();
  });

  // マウス操作での自動カルーセル停止
  tabScroll.addEventListener('mousedown', function() {
    stopAutoCarousel();
  });

  // 初期化実行
  initializeTabs();
  
  // 自動カルーセル開始（少し遅延させて開始）
  setTimeout(function() {
    if (settings.enableAutoCarousel && !isAutoCarouselStopped && settings.totalTabs > 1) {
      startAutoCarousel();
    }
  }, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
